// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "my-edex-empty-state{width:100%;height:100%;position:relative}my-edex-empty-state .empty-state-icon{margin-top:100px;max-width:100%}my-edex-empty-state div{margin-top:8px;line-height:48px;text-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
